import makeStyles from '@mui/styles/makeStyles';

const barHeight = 3;
const barRadius = 4;

export default makeStyles((theme) => ({
    counterBoxContainer: {
        width: theme.typography.pxToRem(180),
        margin: `${theme.typography.pxToRem(24)} auto 0`
    },
    topRow: {
        marginBottom: theme.typography.pxToRem(7)
    },
    topRowText: {
        fontWeight: 600,
        letterSpacing: theme.typography.pxToRem(-0.2)
    },
    boldText: {
        fontWeight: 600
    },
    capsText: {
        textTransform: 'capitalize'
    },
    planIcon: {
        marginRight: theme.typography.pxToRem(5),
        width: theme.typography.pxToRem(13)
    },
    itemsRemainingBar: {
        marginTop: theme.typography.pxToRem(6),
        background: '#BFCFDB',
        height: barHeight,
        borderRadius: barRadius,
        width: '100%'
    },
    remainingItems: ({ percentFilled }) => ({
        background: '#357ABC',
        width: percentFilled,
        borderRadius: barRadius,
        height: '100%'
    }),
    upgradeButton: {
        marginTop: theme.typography.pxToRem(14)
    },
    progressBarRoot: {
        height: 4,
        borderRadius: 5,
        backgroundColor: '#CBD5E1'
    },
    progressBarInner: {
        borderRadius: 5,
        backgroundColor: ({ ninetyPlusUsed }) =>
            ninetyPlusUsed ? '#EF4444' : '#4287CA'
    }
}));
